export const AUTH_USER = 'app/Auth/AUTH_USER';